import React from 'react';
import { ApolloConsumer  } from "react-apollo";
import { Link } from 'react-router-dom';
import { LIMIT_ITEMS_MEDIA } from '../../constants/Common';
import { getMoreMoviesByCate } from '../../graphqlDic';

class CategoryItemsComponent extends React.Component {

    constructor(props) {
        super(props);
        let {category, medias, totalCountMedias} = props.categoryData;
        let cursorMedias = props.categoryData.pageInfoMedias.endCursor;
        let toggleBtnViewMore = medias.length < totalCountMedias ? true : false;
        this.state = {
            toggleBtnViewMore,
            medias: medias ? medias : [],
            cursorMedias,
            category
        }
    }

    componentDidUpdate() {
        this.scrollToBottom();
    }

    scrollToBottom = () => {
        this.contentMovies.scrollIntoView({ behavior: "smooth" });
    }

    onToggleMovie = (param) => {
        let toggleMovie = param === -1 ? true : false;
        if (param !== this.state.toggleMovie) {
            this.setState({
                toggleMovie
            });
        }
    }

    onViewMore = data => {
        console.log(data);
        let { medias } = data.getMoreMoviesByCate;
        let { endCursor } = data.getMoreMoviesByCate.pageInfo;
        if (data && medias.length) {
            let curentMedias = this.state.medias;
            let totalCount = this.props.categoryData.totalCountMedias;
            let newResMedias = curentMedias.concat(medias);
            let toggleBtn = newResMedias.length < totalCount ? true : false;
            this.setState({
                medias: newResMedias,
                cursorMedias: endCursor,
                toggleBtnViewMore: toggleBtn
            })
        }
    }

    showSubItems = medias => {
        let result = [];
        if (typeof medias !== 'undefined') {
            if (medias.length) {
                for (let i in medias) {
                    result.push(
                        <div className="unit" key={i}>
                            <div className="img"><img src={medias[i].img} alt="img" /></div>
                            <div className="name">
                                <a>{medias[i].name}</a>
                            </div>
                            <div className="sub-name">
                                <img src="images/icon-play.png" alt="icon-play" />
                                <Link to={"/media/watch/" + medias[i].id} >{medias[i].sub_name ? medias[i].sub_name : medias[i].name}</Link>
                                <div>IMDb: <span className="point">{medias[i].scoreImdb}</span></div>
                                <div>Tập: {
                                    `${medias[i].episodesCurent}/${medias[i].episodesMax}`
                                }
                                </div>
                                <div>Thể loại: {medias[i].kind}</div>
                                <div>Quốc gia: {medias[i].nation}</div>
                                <div>Ngôn ngữ: {medias[i].languages}</div>
                            </div>
                        </div>
                    );
                }
            }
        }
        return result.length ? result : <span className="text-center">Không có phim nào trong danh sách</span>;
    }

    render(){
        let { category, medias, toggleBtnViewMore } = this.state;
        let cursor = this.state.cursorMedias;
        return(
            <div className="movie-euro" ref={(el) => { this.contentMovies = el; }}>
                <div className="container">
                    <div className="top clearfix">
                        <div className="pull-left">
                            <ul className="list-inline breadcumb">
                                <li><a>TV-Show</a><span> / </span></li>
                                <li>{category.name}</li>
                            </ul>
                        </div>
                    </div>
                    <div className="main clearfix">
                        {this.showSubItems(medias)}
                    </div>
                </div>

                { (toggleBtnViewMore) ? <ApolloConsumer>
                    { client => (
                        <button
                            type="button"
                            className="center-block btn btn-primary"
                            onClick={ async (e) => {
                                let btnViewMore = e.target;
                                btnViewMore.disabled = true;

                                const { data } = await client.query({
                                    query: getMoreMoviesByCate,
                                    variables: {
                                        category_id: category._id,
                                        cursor,
                                        first: LIMIT_ITEMS_MEDIA
                                    }
                                });
                                btnViewMore.disabled = false;

                                this.onViewMore(data);
                            }}
                        >
                        Xem thêm...
                        </button>
                    ) }
                </ApolloConsumer> : null}
            </div>
        );
    }
}

export default CategoryItemsComponent;



// WEBPACK FOOTER //
// ./src/components/TVShow/CategoryItemsComponent.js